import DocumentRetryThanksModal from './DocumentRetryThanksModal';

export default DocumentRetryThanksModal;
